export default __webpack_public_path__ + "static/media/checklist.6b90e9a7.png";